import Link from "next/link"
import { HiOutlineChevronRight } from "react-icons/hi";

const Breadcrumb = (props: any) => {
    const { } = props;
    return (
        <>
            <div className="container">
                <div className="py-4 grid grid-cols-12 gap-4">
                    <div className="col-span-12">
                        <nav className="flex" aria-label="Breadcrumb">
                            <ul className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
                                <li className="inline-flex items-center">
                                    <Link href="/" className="text-[#696969] inline-flex items-center text-sm font-medium hover:text-[#9014DC] dark:text-gray-400 dark:hover:text-white">
                                        Home
                                    </Link>
                                </li>
                                <li>
                                    <div className="flex items-center">
                                        <HiOutlineChevronRight className="text-xs text-[#989898]" />
                                        <Link href="/about-us" className="ms-1 text-sm font-medium text-[#9014DC] hover:text-blue-600 md:ms-2 dark:text-gray-400 dark:hover:text-white">
                                            About Us
                                        </Link>
                                    </div>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Breadcrumb;